import React from "react";

const HelpReportFeebackUploadIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_83_1195)">
        <path
          d="M20.5718 7.71416H16.2861C15.8127 7.71416 15.4289 8.09792 15.4289 8.57133C15.4289 9.04474 15.8127 9.42849 16.2861 9.42849H20.5718C21.0452 9.42849 21.429 9.81225 21.429 10.2857V21.4286C21.429 21.902 21.0452 22.2858 20.5718 22.2858H3.42887C2.95546 22.2858 2.5717 21.902 2.5717 21.4286V10.2856C2.5717 9.8122 2.95546 9.42844 3.42887 9.42844H7.7146C8.18801 9.42844 8.57177 9.04469 8.57177 8.57128C8.57177 8.09787 8.18801 7.71411 7.7146 7.71411H3.42887C2.0087 7.71411 0.857422 8.86539 0.857422 10.2856V21.4285C0.857422 22.8487 2.0087 24 3.42887 24H20.5718C21.992 24 23.1433 22.8487 23.1433 21.4285V10.2856C23.1433 8.86544 21.992 7.71416 20.5718 7.71416Z"
          fill="currentColor"
        />
        <path
          d="M16.8913 4.53671L12.6056 0.25098C12.2709 -0.08366 11.7283 -0.08366 11.3936 0.25098L7.10779 4.53671C6.77892 4.87723 6.78837 5.41984 7.12888 5.74871C7.46106 6.06953 7.98766 6.06953 8.31983 5.74871L11.1425 2.92609V17.1428C11.1425 17.6162 11.5262 18 11.9996 18C12.473 18 12.8568 17.6162 12.8568 17.1428V2.92614L15.6794 5.74876C16.0199 6.07762 16.5625 6.06818 16.8914 5.72766C17.2121 5.39548 17.2121 4.86889 16.8913 4.53671Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_83_1195">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HelpReportFeebackUploadIcon;
